import type { CommandBody } from '../CrossOriginMessage';

/**
 * Indicates the user's geographic position.
 */
export class UserPositionResponseCommandBody implements CommandBody {
  /**
   * User's geographic position.
   */
  userPosition: {
    lat: number;
    lon: number;
  } | null;
}
